<div class="wrapper">
  <div class="field">
    <ng-container #fieldComponent></ng-container>
  </div>

  <a class="field-hint-link" [id]="field.id+'-hint-link'" (click)="[field.hintOnClick()]">{{ field.hintText }}</a>
</div>